import { useRouteData } from "@bcm-dev/bcms-vite";
import { Biller } from "model";

import WidgetView, { WidgetMainContentView } from "compid/shared/views/WidgetView";
import { SVGAsset } from "res";

import "./styles.css";

export default function BillersAddedSuccessPrompt(props) {
    const { route } = useRouteData();
    window.history.replaceState({}, document.title);

    const added = route !== null ? route.addedBillers : false;
    const isShown = added && added.length > 0;
    const useIds = route !== null ? route.useIds : false;

    let billers = [];

    if(isShown) {
        billers = useIds
            ? added.map(id => Biller.initByID(id), [])
            : Biller.initMany(added);
    }

    const listItems = billers.map(biller => <li key={ `Added_${ biller.id }` }>{ biller.name } { biller.number }</li>, []);

    return (
        <>
            {
                isShown && 
                <WidgetView className="billers-added-prompt">
                    <div className="flex-container flex-width flex-vertical">
                        <WidgetMainContentView className="flex-container align-top">
                            <SVGAsset className="icon set-width" id="CheckmarkIcon" />
                            <p className="flex-width">
                                <b data-point="Billers_Added_Success_Prompt">Success! The following biller(s) have been added and are ready to be paid.</b>
                            </p>
                        </WidgetMainContentView>

                        <WidgetMainContentView className="biller-list">
                            <ul>{ listItems }</ul>
                        </WidgetMainContentView>
                    </div>
                </WidgetView>
            }
        </>
    );
}